module.exports = __webpack_public_path__ + "img/9_High-body.beb7e38a.png";